import { Component } from 'react';
import { emitAppError } from '../lib/debug';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const where = (info && info.componentStack) || '';
    emitAppError(`React crashed: ${error?.message || error}`, [where.trim().split('\n')[0] || '']);
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '2rem', maxWidth: 720, margin: '2rem auto' }}>
          <div
            style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              color: '#7f1d1d',
              borderRadius: 12,
              padding: '1.2rem 1.4rem',
            }}
          >
            <h4 style={{ fontWeight: 700, margin: '0 0 0.4rem' }}>Something went wrong rendering this page.</h4>
            <div style={{ fontFamily: 'ui-monospace, monospace', fontSize: '0.85rem' }}>
              {String(this.state.error?.message || this.state.error)}
            </div>
            <button
              type="button"
              onClick={() => this.setState({ error: null })}
              style={{
                marginTop: '1rem',
                background: '#dc2626',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 16px',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
